export const auditLogsConstants = {

    GETALL_REQUEST_AUDIT: 'GETALL_REQUEST_AUDIT',
    GETALL_SUCCESS_AUDIT: 'GETALL_SUCCESS_AUDIT',
    GETALL_FAILURE_AUDIT: 'GETALL_FAILURE_AUDIT',

};